import './component.scss'
import 'Components/refosumu/shared/subsidy_bookmark_button/component'
import '@stimulus/polyfills'
import { Application, Controller } from 'stimulus'

const app = Application.start()

app.register('subsidies-summary-card', class extends Controller {
  static targets = ['moreButton', 'hiddenItem', 'constructionsBox']

  showMore(event) {
    event.preventDefault()

    // 隠れている項目を表示
    this.hiddenItemTargets.forEach(item => {
      item.classList.remove('subsidies-summary-card__accordion-item--hidden')
    })

    // もっと見るボタンを隠す
    event.target.closest('.subsidies-summary-card__accordion-more').style.display = 'none'

    // 注釈を表示
    if (this.hasConstructionsBoxTarget) {
      const noteElement = document.createElement('div')
      noteElement.className = 'subsidies-summary-card__accordion-note'
      noteElement.textContent = '詳しくは詳細ページをご確認ください'
      this.constructionsBoxTarget.appendChild(noteElement)
    }
  }
})
